import { useMemo } from "react";

import { useQuery } from "@tanstack/react-query";

import { getFarmReportingYear } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE_TIME, GET_FARM_REPORTING_YEAR } from "consts";

import { FarmReportingYearResponse } from "models";

const env = getEnvironment();

export const useGetFarmReportingYear = (farmId: string | null) => {
  const queryResult = useQuery<FarmReportingYearResponse>({
    queryKey: [GET_FARM_REPORTING_YEAR, farmId],
    queryFn: getFarmReportingYear,
    enabled: !!farmId && !env.admin,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });

  const isLoading = useMemo(
    () => !!farmId && !env.admin && (queryResult.isPending || (queryResult.data === undefined && !queryResult.isError)),
    [farmId, queryResult.isPending, queryResult.data, queryResult.isError]
  );

  return {
    data: queryResult.data ?? { activeFarmReportingYear: undefined, isReportingYearLocked: false },
    isError: queryResult.isError,
    isLoading,
    isPending: queryResult.isPending,
  };
};
